import { darkModalOutline } from "Styles/darkModal";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.neutral.black};
  display: flex;
  grid-area: headerRight;
  height: 90px;
  justify-content: space-between;
  padding: 16px 20px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  gap: 15px;
  flex-direction: column;
  z-index: 10;

  ${media.greaterThan("1260px")`
    position: fixed;
    height: 72px;
    z-index: 1;
    right: 0;
    gap: 0px;
    padding: 16px 64px;
    display: flex;
    flex-direction: row;
    z-index: 10;
  `}
`;

export const Side = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  height: 100%;
`;

export const Link = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Auth = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.white};
    text-decoration: underline;
  }
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 30px;
  height: 100%;

  color: ${({ theme }) => theme.colors.neutral.white};

  cursor: ${({ pointer }) => pointer && "pointer"};

  ${media.lessThan("1260px")`
    p {
      display: none;
    }
  `}
`;

export const PageLink = styled.div`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  cursor: pointer;
  position: relative;

  ${({ $active, theme }) =>
    $active &&
    `
    ::after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 100%;
      height: 4px;
      background-color: ${theme.colors.neutral.white};
    }
  `}
`;

export const InvisibleBackground = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
`;

export const Modal = styled.div`
  position: absolute;
  top: 60px;
  left: 130px;

  background-color: ${({ theme }) => theme.colors.neutral.black};

  width: 200px;
  height: fit-content;

  display: flex;
  flex-direction: column;
  gap: 10px;

  /* Contorno: sem ele o modal se funde ao fundo preto da pagina. */
  ${darkModalOutline}
`;

export const AuthModal = styled.div`
  position: absolute;
  top: 60px;
  left: ${({ auth }) => (auth ? "-100" : "-180")}px;

  background-color: ${({ theme }) => theme.colors.neutral.black};
  border: 1px solid #4a5568;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

  width: 300px;
  height: fit-content;
  padding: 20px;

  display: flex;
  flex-direction: column;
  gap: 15px;

  h2 {
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  form {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  ${media.lessThan("medium")`
    left: -100px;
  `}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ModalItem = styled.div`
  width: 100%;
  height: fit-content;

  cursor: pointer;
  padding: 15px 10px;

  display: flex;
  align-items: center;

  ${({ active, theme }) =>
    active &&
    `
    border-left: 3px solid ${theme.colors.primary.green};
  `}
`;

export const Notifications = styled.div`
  position: relative;
  cursor: pointer;
`;

export const NotificationDot = styled.div`
  /* Vermelho (D5 da parte 4): o badge deixou de anunciar "ha notificacao" e
     passou a anunciar ALERTA — algo que exige acao. O token
     feedbackState.critical existe nos DOIS temas; feedback.error so existe no
     comum e quebraria o admin.
     ATENCAO: nada de crase neste comentario — ele vive dentro de um template
     literal do styled-components, e a crase ENCERRA o template. */
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: 0;
  right: 0;
`;

export const CaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 10px 0;
  padding: 0 8px;
`;

export const LoginModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const LoginModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 12px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

  ${media.lessThan("medium")`
    padding: 30px 20px;
  `}
`;

export const LoginModalClose = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const LoginModalHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.neutral.cinza800};
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.cinza600};
    line-height: 1.5;
  }
`;

export const LoginModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;

  ${media.lessThan("medium")`
    gap: 10px;
  `}
`;

export const ForgotPasswordLink = styled.button`
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  cursor: pointer;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;
